import { render } from "./TeamMembers.vue?vue&type=template&id=240479fb&scoped=true&ts=true"
import script from "./TeamMembers.vue?vue&type=script&lang=ts"
export * from "./TeamMembers.vue?vue&type=script&lang=ts"

import "./TeamMembers.vue?vue&type=style&index=0&id=240479fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240479fb"]])

export default __exports__